<div class="flex justify-end">
  <div class="max-w-[80%]">
    <div class="bg-gray-100 px-4 py-2 pr-7 rounded-lg whitespace-pre-wrap relative group">
      <ng-container *ngFor="let block of message.data">
        <div *ngIf="block.type === ContentBlockType.Text">
          <div class="leading-snug">{{ block.content }}</div>
        </div>
      </ng-container>
      <sbnb-cs-debug-item *ngIf="message.uuid" label="copilot_message_uuid" [value]="message.uuid">
      </sbnb-cs-debug-item>
    </div>
  </div>
</div>

<div *ngIf="hasError && !progressMessage" class="flex justify-start">
  <div class="max-w-[80%] my-2" data-testid="copilot-error-message">
    <ui-alert
      [type]="'hovering'"
      [color]="'brand'"
      [icon]="'griddy-info-circle'"
      [title]="'Oops'"
      [message]="'Seems like an error occurred. I was unable to process your request at this time'"
      [action]="{ label: 'Retry', onClick: onRetryClick.bind(this) }"
      [hideCloseButton]="true">
    </ui-alert>
  </div>
</div>
